import { Suspense, type ReactNode } from 'react';
import { Spinner } from '@/shared/ui/feedback/Spinner';

type Props = {
  children: ReactNode;
  loading?: ReactNode;
};

const DefaultLoading = () => (
  <div className="flex min-h-[50vh] items-center justify-center">
    <Spinner size="lg" />
  </div>
);

export const SuspensePage = ({ children, loading }: Props) => (
  <Suspense fallback={loading ?? <DefaultLoading />}>{children}</Suspense>
);
